<template>
  <div>
    <roe-article-form
      ref="form"
      :articles="reportSavingArticles"
      :category-articles="savingArticles"
    >
    </roe-article-form>
    <roe-article-list
      :articles="reportSavingArticles"
      :article-form="$refs.form"
    ></roe-article-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ARTICLES_FETCH, REPORT_ARTICLES_FETCH } from "@/store/actions.type";
import RoeArticleList from "@/components/articles/ArticleList";
import RoeArticleForm from "@/components/articles/ArticleForm";
export default {
  name: "RoeIndependentResearchProvides",
  components: { RoeArticleForm, RoeArticleList },
  mounted() {
    this.$store.dispatch(ARTICLES_FETCH);
    this.$store.dispatch(REPORT_ARTICLES_FETCH, this.$route.params.id);
  },
  computed: {
    ...mapGetters(["savingArticles", "reportSavingArticles"])
  }
};
</script>
